import { Navigate, Outlet } from "react-router-dom";
import { getLocalStorage, isAuthenticated } from "../utils/helpers";

const UnAuthorizeRoutes = () => {
  const userRole = getLocalStorage("userRole");
  const layoutView = getLocalStorage("layoutView") || (userRole ? userRole?.toLowerCase() : null);
  
  if (isAuthenticated()) {
    return layoutView === "admin" ? <Navigate to="/" replace /> : <Navigate to="/tenant/users/dashboard" replace />;
  }

  return <Outlet />;
};

export default UnAuthorizeRoutes;